<div
  class="warning d-flex w-100 {{ type }}"
  [class.d-none]="!text && !hasChildContent"
>
  <div class="warning__content d-flex align-items-center w-100">
    <i
      class="warning__icon ri-alert-line"
      [class.ri-alert-line]="type === 'warning'"
      [class.ri-error-warning-line]="type === 'error'"
    ></i>

    <div *ngIf="text" class="warning__text">{{ text }}</div>

    <ng-content></ng-content>
  </div>
</div>
